import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

const freeConsultationText = css`
  margin-bottom: 8px;
`;

type AnySolutionProps = {
  onConsultationSignupBtnClick: () => void;
};

export const AnySolution = ({ onConsultationSignupBtnClick }: AnySolutionProps) => (
  <>
    <ModalHeader title="Решение под любой запрос" />
    <ModalContent>
      <Typography className={freeConsultationText} variant="m" size="body_long">
        Изготовим дверь под любой запрос&nbsp;&mdash; от&nbsp;простой до&nbsp;высокотехнологичной двери
        с&nbsp;электронным замком, с&nbsp;удобным сканом биометрии для входа и&nbsp;с&nbsp;возможностью
        подключения к&nbsp;системе &laquo;Умный дом&raquo;.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementText="Оставить заявку"
        elementName="Решение под любой запрос"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
